import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'power3.out', type, elementToAnimate, delayValue }) {
  let animation;
  duration = duration * speed;
  let steps = elementToAnimate?.length || 1;
  if (type == 'entry') {
    animation = gsap.from(elementToAnimate, {
      duration: duration,
      pixi: {
        alpha: 0,
      },
      repeat: 0,
      ease: 'power3.in',
      delay: delayValue,
      stagger: duration / steps,
    });
  } else {
    animation = gsap.to(elementToAnimate, {
      duration: duration,
      pixi: {
        alpha: 0,
      },
      repeat: 0,
      delay: steps > 1 ? delayValue - duration : delayValue,
      ease: 'power3.in',
      stagger: duration / steps,
    });
  }
  return animation;
}
export default { Animate };
